import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/dot-circle': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 56C366.5 56 456 145.5 456 256 456 366.5 366.5 456 256 456 145.5 456 56 366.5 56 256 56 145.5 145.5 56 256 56M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM256 176C211.8 176 176 211.8 176 256S211.8 336 256 336 336 300.2 336 256 300.2 176 256 176z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/dot-circle.js
// module id = 257D
// module chunks = 144